import { findWhere } from 'underscore';
import deviceManagementService from '@/modules/device-management/services/deviceManagementService';
import { DmInstaller } from './services/dmInstallerService';
import { LSInstaller } from './services/lsInstallerService';
import { DeviceInstaller } from './interfaces/DeviceInstaller';

const getUrlParameter = (name: string): string => {
  // eslint-disable-next-line no-param-reassign
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${name}=([^&#]*)`);
  const results = regex.exec(window.location.search);
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};

export const getApplicationRuntime = (): { flag: string, service: DeviceInstaller } => {
  const runtimes = {
    NAR: { // nsoft appliction runtime
      flag: 'nar',
      service: DmInstaller,
    },
    LS: { // local storage
      flag: 'ls',
      service: LSInstaller,
    },
    DM: { // device management
      flag: 'dm',
      service: deviceManagementService as unknown as DeviceInstaller,
    },
  };
  const runtime = findWhere(runtimes, { flag: getUrlParameter('ar') });
  return runtime || runtimes.NAR;
};

export const isDmApplicationRuntime = (): boolean => getApplicationRuntime().flag === 'dm';

/**
   * In future we must change this code to use development parametar
   * instead of debug. Debug is used for log level while development would
   * mark development mode.
   */
export const isDevelopmentMode = () => !!getUrlParameter('debugMode');
